/**
 * @flow
 * @relayHash 4e5f117a344ae7a08b1aa6e86e5d925c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type undoImportInput = {|
  clientMutationId?: ?string,
  propertyId: string,
  logId: string,
|};
export type undoImportMutationVariables = {|
  input: undoImportInput
|};
export type undoImportMutationResponse = {|
  +undoImport: ?{|
    +importLog: ?{|
      +id: string,
      +createdAt: any,
      +fileName: string,
      +importedAt: ?any,
      +importedBy: string,
      +totalRows: number,
      +successCount: number,
      +failureCount: number,
      +contactsBeforeLoad: number,
      +contactsAfterLoad: number,
    |}
  |}
|};
export type undoImportMutation = {|
  variables: undoImportMutationVariables,
  response: undoImportMutationResponse,
|};
*/


/*
mutation undoImportMutation(
  $input: undoImportInput!
) {
  undoImport(input: $input) {
    importLog {
      id
      createdAt
      fileName
      importedAt
      importedBy
      totalRows
      successCount
      failureCount
      contactsBeforeLoad
      contactsAfterLoad
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "undoImportInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "undoImport",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "undoImportPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "importLog",
        "storageKey": null,
        "args": null,
        "concreteType": "ImportLog",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "importedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "importedBy",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalRows",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "successCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "failureCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactsBeforeLoad",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactsAfterLoad",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "undoImportMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "undoImportMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "undoImportMutation",
    "id": null,
    "text": "mutation undoImportMutation(\n  $input: undoImportInput!\n) {\n  undoImport(input: $input) {\n    importLog {\n      id\n      createdAt\n      fileName\n      importedAt\n      importedBy\n      totalRows\n      successCount\n      failureCount\n      contactsBeforeLoad\n      contactsAfterLoad\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '750d9fd85aae0afa0965ef8537f83c05';
module.exports = node;
